import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { applyBuildInfoMarker } from 'app/core/startup/apply-build-info-marker';
import { applyE2eSwBuildMarker } from 'app/core/startup/e2e-sw-build-marker';
import { showStartupError } from 'app/core/startup/startup-error';

applyE2eSwBuildMarker();
applyBuildInfoMarker();

bootstrapApplication(AppComponent, { ...appConfig }).catch((err) => {
    console.error(err);
    showStartupError();
});
